import * as React from "react";
import { useCallback } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";

interface NavBarProps {
    hideLogout: boolean;
}

const LIMIT = 10;

const NavBar = (props: NavBarProps) => {
    const [clickCount, setClickCount] = useState<number>(0);

    const handleHrLogout = useCallback(() => {
        localStorage.clear();
        location.reload();
    }, []);

    const handleApplicantLogout = useCallback(() => {
        location.reload();
    }, []);

    const handleIncreaseCount = useCallback(() => {
        setClickCount(clickCount + 1);
    }, []);

    return (
        <nav className="navbar navbar-expand-lg bg-secondary NavBar__root" id="mainNav" onClick={handleIncreaseCount}>
            <div className="container" >
                <Link to={"/"}>
                    <div className="navbar-brand js-scroll-trigger">MedFlyt HR</div>
                </Link>
                <button
                    className="navbar-toggler navbar-toggler-right text-uppercase bg-primary text-white rounded"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarResponsive"
                    aria-controls="navbarResponsive"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    Menu
                    <i className="fa fa-bars"/>
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item mx-0 mx-lg-1">
                            <Link
                                to={"/"}
                                className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
                                onClick={handleApplicantLogout}
                            >
                                Applicant Logout
                            </Link>
                        </li>
                        {(props.hideLogout ? clickCount >= LIMIT : true) ?
                        <li className="nav-item mx-0 mx-lg-1">
                            <a
                                className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
                                onClick={handleHrLogout}
                            >
                                HR Logout
                            </a>
                        </li> : null}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/widgets/NavBar.tsx